import React from 'react';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

import { ReactComponent as RefreshIcon } from '../../../assets/images/refresh.svg';
import { ReactComponent as MoneyIcon } from '../../../assets/images/money.svg';
import { ReactComponent as MergeIcon } from '../../../assets/images/merge.svg';
import { ReactComponent as AddIcon } from '../../../assets/images/add-circle-white.svg';

const PlanogramSelectionMenu = ({
    isSelectionMode,
    selectedCells,
    onAssignProduct,
    onClearSelectedCells,
    onChangePriceForSelected,
    onMergeSelected,
    onCancelSelection,
    allSelectedCellsHaveProducts,
}) => {
    const { t } = useTranslation();

    if (!isSelectionMode) {
        return null;
    }

    return (
        <div className="selection-mode-menu">
            <div className="selection-info">
                <span className="selected-count">
                    {t('planogram.selection.selected')}: {selectedCells.size}
                </span>
            </div>

            <div className="selection-actions">
                <Button
                    className="p-button-primary small"
                    onClick={onAssignProduct}
                    disabled={selectedCells.size === 0}
                >
                    <AddIcon />

                    <span className="p-button-label pl-2">
                        {t('planogram.selection.assignProduct')}
                    </span>
                </Button>

                <Button
                    className="p-button-danger small"
                    onClick={onClearSelectedCells}
                    disabled={selectedCells.size === 0}
                >
                    <RefreshIcon />

                    <span className="p-button-label pl-2">
                        {t('planogram.selection.clearCells')}
                    </span>
                </Button>

                <Button
                    className="p-button-primary small"
                    onClick={onChangePriceForSelected}
                    disabled={
                        selectedCells.size === 0 ||
                        !allSelectedCellsHaveProducts
                    }
                >
                    <MoneyIcon />

                    <span className="p-button-label pl-2">
                        {t('planogram.selection.changePrice')}
                    </span>
                </Button>

                <Button
                    className="p-button-info small"
                    onClick={onMergeSelected}
                    disabled={selectedCells.size < 2}
                >
                    <MergeIcon />

                    <span className="p-button-label pl-2">
                        {t('planogram.selection.merge')}
                    </span>
                </Button>

                <Button
                    className="p-button-cancel small"
                    onClick={onCancelSelection}
                >
                    <i className="pi pi-check-circle" />

                    <span className="p-button-label pl-2">
                        {t('planogram.selection.done')}
                    </span>
                </Button>
            </div>
        </div>
    );
};

export default PlanogramSelectionMenu;